// PKCE (RFC 7636) helpers for the OIDC authorization-code flow. Implemented on
// WebCrypto alone — no external dependency — so the SPA stays dependency-light and
// the code_verifier never leaves the browser (S256: only its SHA-256 challenge is
// sent to the IdP; the verifier is presented once at the token exchange).

const VERIFIER_BYTES = 32;

/** URL-safe base64 (no padding) — the encoding PKCE + OAuth state expect. */
function base64UrlEncode(bytes: ArrayBuffer | Uint8Array): string {
  const arr = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let str = "";
  for (const b of arr) str += String.fromCharCode(b);
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/** Cryptographically-random URL-safe string for the code_verifier / state / nonce. */
export function randomUrlSafe(bytes = VERIFIER_BYTES): string {
  const buf = new Uint8Array(bytes);
  crypto.getRandomValues(buf);
  return base64UrlEncode(buf);
}

/** S256 code_challenge for a verifier (base64url(SHA-256(verifier))). */
export async function codeChallengeS256(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  return base64UrlEncode(digest);
}
